import { render, staticRenderFns } from "./carts.vue?vue&type=template&id=5f08993a&scoped=true"
import script from "./carts.vue?vue&type=script&lang=js"
export * from "./carts.vue?vue&type=script&lang=js"
import style0 from "./carts.vue?vue&type=style&index=0&id=5f08993a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f08993a",
  null
  
)

export default component.exports